import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import {
  CANNED_RESPONSE_PERMISSIONS,
  CANNED_RESPONSE_PUBLIC_PERMISSIONS,
  CANNED_RESPONSE_PRIVATE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
const CannedHome = () => import('./Index.vue');
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/canned-response'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'canned_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'canned_list',
          meta: {
            featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
            permissions: [
              'administrator',
              CANNED_RESPONSE_PERMISSIONS,
              CANNED_RESPONSE_PUBLIC_PERMISSIONS,
              CANNED_RESPONSE_PRIVATE_PERMISSIONS,
            ],
          },
          component: CannedHome,
        },
      ],
    },
  ],
};
